import { useSession } from '../Context';

const Unauthenticated = ({ loginComponent: Login, setState }) => {
  const { setSession } = useSession();
  return (
    <Login
      onSuccess={(session) => {
        setSession(session);
        setState('AUTHENTICATED');
      }}
    />
  );
};
export default Unauthenticated;
